import { useContext } from "react";
import { ThemeContext } from "./theme-context";

function PortfolioAbout() {
    const themeContext = useContext(ThemeContext);

    const exps = [
        {
            title: 'Title #1',
            yrs: 5,
            percent: 66,
        },
    ];

    const tempExps = (
        <ul>
            <li>
                <h5>PHP</h5>
                <div className="clm-sk-cont">
                    <div className="clm-sk-cont-2">
                        <div className="clm-sk-yrs">8 Years Experience</div>
                        <div className="clm-sk-percent">95%</div>
                        <div className="clm-sk-percent-2" style={{width: '95%'}}>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>
            </li>
            <li className="li-parent">
                <ul>
                    <li>
                        <h5>Laravel</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">7 Years Experience</div>
                                <div className="clm-sk-percent">95%</div>
                                <div className="clm-sk-percent-2" style={{width: '95%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5>CodeIgniter</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">3 Years Experience</div>
                                <div className="clm-sk-percent">90%</div>
                                <div className="clm-sk-percent-2" style={{width: '90%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5>Zend</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">1 Year Experience</div>
                                <div className="clm-sk-percent">80%</div>
                                <div className="clm-sk-percent-2" style={{width: '80%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5 className="size-1">WordPress CMS</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">5 Years Experience</div>
                                <div className="clm-sk-percent">90%</div>
                                <div className="clm-sk-percent-2" style={{width: '90%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5>Joomla CMS</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">1 Year Experience</div>
                                <div className="clm-sk-percent">75%</div>
                                <div className="clm-sk-percent-2" style={{width: '75%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5>SQL (MYSQL)</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">7 Years Experience</div>
                                <div className="clm-sk-percent">95%</div>
                                <div className="clm-sk-percent-2" style={{width: '95%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </li>
            <li>
                <h5 className="size-1">Javascript (JS)</h5>
                <div className="clm-sk-cont">
                    <div className="clm-sk-cont-2">
                        <div className="clm-sk-yrs">7 Years Experience</div>
                        <div className="clm-sk-percent">95%</div>
                        <div className="clm-sk-percent-2" style={{width: '95%'}}>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>
            </li>
            <li className="li-parent">
                <ul>
                    <li>
                        <h5>JQuery</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">7 Years Experience</div>
                                <div className="clm-sk-percent">95%</div>
                                <div className="clm-sk-percent-2" style={{width: '95%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5>AngularJS</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">2 Years Experience</div>
                                <div className="clm-sk-percent">90%</div>
                                <div className="clm-sk-percent-2" style={{width: '90%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5>VueJS</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">3 Years Experience</div>
                                <div className="clm-sk-percent">95%</div>
                                <div className="clm-sk-percent-2" style={{width: '95%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5>ReactJS</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">1 Year Experience</div>
                                <div className="clm-sk-percent">95%</div>
                                <div className="clm-sk-percent-2" style={{width: '95%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </li>
            <li>
                <h5 className="size-1">NPM (Node.js)</h5>
                <div className="clm-sk-cont">
                    <div className="clm-sk-cont-2">
                        <div className="clm-sk-yrs">5 Years Experience</div>
                        <div className="clm-sk-percent">90%</div>
                        <div className="clm-sk-percent-2" style={{width: '90%'}}>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>
            </li>
            <li className="li-parent">
                <ul>
                    <li>
                        <h5 className="size-1">Gulp / Bower / Webpack</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">5 Years Experience</div>
                                <div className="clm-sk-percent">90%</div>
                                <div className="clm-sk-percent-2" style={{width: '90%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5 className="size-1">LESS / SCSS / Stylus</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">7 Years Experience</div>
                                <div className="clm-sk-percent">95%</div>
                                <div className="clm-sk-percent-2" style={{width: '95%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </li>
            <li>
                <h5>CSS/CSS3</h5>
                <div className="clm-sk-cont">
                    <div className="clm-sk-cont-2">
                        <div className="clm-sk-yrs">8 Years Experience</div>
                        <div className="clm-sk-percent">95%</div>
                        <div className="clm-sk-percent-2" style={{width: '95%'}}>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>
            </li>
            <li className="li-parent">
                <ul>
                    <li>
                        <h5 className="size-1">LESS / SCSS / Stylus</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">5 Years Experience</div>
                                <div className="clm-sk-percent">95%</div>
                                <div className="clm-sk-percent-2" style={{width: '95%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5 className="size-1">Twitter Bootstrap</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">4 Years Experience</div>
                                <div className="clm-sk-percent">90%</div>
                                <div className="clm-sk-percent-2" style={{width: '90%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5 className="size-1">TailwindCSS</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">2 Years Experience</div>
                                <div className="clm-sk-percent">95%</div>
                                <div className="clm-sk-percent-2" style={{width: '95%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </li>
            <li>
                <h5>HTML/HTML5</h5>
                <div className="clm-sk-cont">
                    <div className="clm-sk-cont-2">
                        <div className="clm-sk-yrs">8 Years Experience</div>
                        <div className="clm-sk-percent">95%</div>
                        <div className="clm-sk-percent-2" style={{width: '95%'}}>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>
            </li>
            <li className="li-parent">
                <ul>
                    <li>
                        <h5 className="size-1">Jade/Pug Template</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">6 Years Experience</div>
                                <div className="clm-sk-percent">95%</div>
                                <div className="clm-sk-percent-2" style={{width: '95%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </li>
            <li>
                <h5 className="size-1">Version Control</h5>
                <div className="clm-sk-cont">
                    <div className="clm-sk-cont-2">
                        <div className="clm-sk-yrs">7 Years Experience</div>
                        <div className="clm-sk-percent">95%</div>
                        <div className="clm-sk-percent-2" style={{width: '95%'}}>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>
            </li>
            <li className="li-parent">
                <ul>
                    <li>
                        <h5>Git/SVN</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">8 Years Experience</div>
                                <div className="clm-sk-percent">95%</div>
                                <div className="clm-sk-percent-2" style={{width: '95%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </li>
            {/* <li>
                <h5>Others</h5>
                <div className="clm-sk-cont clm-sk-hide">
                    <div className="clm-sk-cont-2">
                        <div className="clm-sk-yrs">false Years Experience</div>
                        <div className="clm-sk-percent">false%</div>
                        <div className="clm-sk-percent-2" style={{width: false%'}}>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>
            </li> TODO: */}
            <li className="li-parent">
                <ul>
                    <li>
                        <h5>Photoshop</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">5 Years Experience</div>
                                <div className="clm-sk-percent">85%</div>
                                <div className="clm-sk-percent-2" style={{width: '85%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5>Illustrator</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">2 Years Experience</div>
                                <div className="clm-sk-percent">85%</div>
                                <div className="clm-sk-percent-2" style={{width: '85%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5 className="size-1">Word Office Tools</h5>
                        <div className="clm-sk-cont">
                            <div className="clm-sk-cont-2">
                                <div className="clm-sk-yrs">6 Years Experience</div>
                                <div className="clm-sk-percent">90%</div>
                                <div className="clm-sk-percent-2" style={{width: '90%'}}>
                                    <div>&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
    )

    const getExps = () => {
        let ret = tempExps;
        if(themeContext.value.env === 'dev') {
            ret = <ul>
                { exps.map(v => <li>
                    <h5>{v.title}</h5>
                    <div className="clm-sk-cont">
                        <div className="clm-sk-cont-2">
                            <div className="clm-sk-yrs">{v.yrs} Years Experience</div>
                            <div className="clm-sk-percent">{v.percent}%</div>
                            <div className="clm-sk-percent-2" style={{width: `${v.percent}%`}}>
                                <div>&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </li>) }
            </ul>
        }
        return ret;
    }

    return (
        <div className="clm-about clm-fixed-hc" id="about">
            <div className="clm-inner-container clm-container">
                <div className="clm-title">
                    <h4>ABOUT </h4>
                </div>
                <div className="row">
                    <div className="col-md-6 text-center">
                        <div className={`clm-profile ${themeContext.value.env}`}>
                            <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="/theme/images/profile.jpg" alt="Carl Louis Manuel"/>
                        </div>
                        {themeContext.value.env === 'dev' && (<>
                            <h6>Hello</h6>
                            <p>World World World World World World World World World World World World World World World World World World World </p>
                        </>)}
                        {themeContext.value.env !== 'dev' && (<>
                            <h6>I'm Carl Louis Manuel</h6>
                            <p>&ldquo;I am a fullstack web developer working for over 12 years since 2012, I am mainly focused on web development using HTML, CSS, JS (AngularJS, VueJS, JQuery), PHP/MySQL - (XAMPP, WAMP, LAMP). I build website from scratch using any top frameworks such as Laravel, Codeigniter, and Zend on any development environment with support of Linux command or local development environment and my code is up to the current standards, secure, and safe from SQL injections or similar hacking attempts with understanding of OOP. I could be a maintenance support with high analytical thinking skill to solve complex problems. All the websites I developed was built using the latest version of PHP. I have knowledge on building a website from CMS such as Wordpress, Drupal and Joomla, I could make customized themes. I have experienced in SEO friendly website that may affect the visibility of a website or a web page in a search engine’s results. I always adopt latest technologies to meet the market requirements and I am creating a responsive web design that loads correctly in all modern browsers and smaller devices.&rdquo;</p>
                        </>)}
                    </div>
                    <div className="clm-skills col-md-6 text-center">
                        {getExps()}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PortfolioAbout;